// extracted by mini-css-extract-plugin
export var logo = "_kw-2";
export var logoWrapper = "_kw-1";
export var strip = "_kw-0";